// src/components/QrScannerNav.jsx
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Html5QrcodeScanner } from 'html5-qrcode';
import {
  Box,
  Button,
  Typography,
  IconButton,
} from '@mui/material';
import {
  ArrowBack,
  Image as ImageIcon,
} from '@mui/icons-material';
export default function QrScannerNav() {
  const history = useHistory();

  useEffect(() => {
    const config = {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      rememberLastUsedCamera: true
    };

    const scanner = new Html5QrcodeScanner(
      'qr-reader',
      config,
      /* verbose= */ false
    );

    scanner.render(
      (decodedText) => {
        scanner.clear().then(() => {

          
    history.push(`/motorista/v1/finalizar?id=${encodeURIComponent(decodedText)}`);

        
        });
      },
      (errorMessage) => {
        // opcional: console.warn(errorMessage);
      }
    );

    return () => {
      scanner.clear().catch(() => {});
    };
  }, [history]);

  return (
    
    <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={4}>
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          left: 16,
          zIndex: 1000
        }}
      >
        <IconButton
          onClick={() => {
                    localStorage.clear();
                    window.location.href = "/auth";
                  }}
          sx={{
            bgcolor: 'background.paper',
            boxShadow: 2,
            '&:hover': { bgcolor: 'grey.200' }
          }}
        >
          <ArrowBack />
        </IconButton>
      </Box>
      <Box id="qr-reader" sx={{ width: 320 }} />
      <Typography variant="body2" color="textSecondary">
        Aponte a câmera para um QR Code
      </Typography>
     
    </Box>
  );
}
